<div tabindex="0" id="menu-profile-container">
    <div>
        <ng-container [ngTemplateOutlet]="menuProfile"> </ng-container>
    </div>
</div>

<ng-template #menuProfile>
    <ul id="menu-profile" class="unstyled-ul">
        <li id="account-settings-item">
            <a [href]="accountOverviewUrl()">
                <button id="account-settings" tabindex="-1">
                    <div class="btn-icon" id="account-settings-icon">
                        <i class="fa-light fa-user-gear"></i>
                    </div>
                    <label for="account-settings-icon" id="account-settings-label">{{
                        'profileMenu.accountSettings' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="message-settings-item">
            <a [href]="bannerSettingsUrl">
                <button id="message-settings" tabindex="-1">
                    <div class="btn-icon" id="message-settings-icon">
                        <i class="fa-light fa-message-lines"></i>
                    </div>
                    <label for="message-settings-icon" id="message-settings-label">{{
                        'profileMenu.bannerManagement' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="sign-out-item">
            <button id="sign-out-link" (click)="logout()">
                <div class="btn-icon" id="sign-out-icon">
                    <i class="fa-light fa-right-from-bracket"></i>
                </div>
                <label for="sign-out-icon" id="sign-out-label">{{ 'profileMenu.signOut' | translate }}</label>
            </button>
        </li>
    </ul>
</ng-template>
